export enum SubscriptionModelTypesEnum {
	KEY_MEASURE = 'Key Measure',
	DIMENSION = 'Dimension',
	ATTRIBUTE = 'Attribute',
}
